import React from "react";
import { ResponsivePie } from "@nivo/pie";
import { formatNumberWithCommas } from "functions";
import { DEVICE_COLORS, DEVICE_LABELS } from "./VisitorsChart";

// Donut of unique visitors by device for the selected range, with a legend
// underneath. `devices` is { mobile, desktop, unknown } from the stats
// endpoint.
function DevicePie({ devices }) {
  const entries = ["mobile", "desktop", "unknown"]
    .map((key) => ({ key, value: devices?.[key] || 0 }))
    .filter((d) => d.value > 0);
  const total = entries.reduce((sum, d) => sum + d.value, 0);

  if (total === 0) {
    return (
      <div style={{ opacity: 0.55, fontSize: "14px" }}>
        No traffic in this range yet.
      </div>
    );
  }

  const pct = (n) => Math.round((n / total) * 100);
  const data = entries.map((d) => ({
    id: DEVICE_LABELS[d.key],
    value: d.value,
    color: DEVICE_COLORS[d.key],
  }));

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
      <div className="pointer-events" style={{ height: "220px" }}>
        <ResponsivePie
          data={data}
          margin={{ top: 16, right: 16, bottom: 16, left: 16 }}
          innerRadius={0.6}
          padAngle={1.5}
          cornerRadius={3}
          colors={{ datum: "data.color" }}
          tooltip={({ datum }) => (
            <div
              style={{
                background: "#111115",
                border: "1px solid rgba(255,255,255,0.12)",
                borderRadius: "8px",
                padding: "9px 13px",
                fontSize: "13px",
                color: "#f0ede8",
                pointerEvents: "none",
                boxShadow: "0 4px 20px rgba(0,0,0,0.5)",
                display: "flex",
                alignItems: "center",
                gap: "7px",
                whiteSpace: "nowrap",
              }}
            >
              <span
                style={{
                  display: "inline-block",
                  width: 9,
                  height: 9,
                  borderRadius: 2,
                  background: datum.color,
                  flexShrink: 0,
                }}
              />
              <span style={{ opacity: 0.8 }}>{datum.id}</span>
              <span style={{ fontWeight: 700 }}>
                {formatNumberWithCommas(datum.value)}
              </span>
              <span style={{ opacity: 0.55, fontSize: "12px" }}>
                ({pct(datum.value)}%)
              </span>
            </div>
          )}
          enableArcLinkLabels={false}
          arcLabel={(d) => `${pct(d.value)}%`}
          arcLabelsSkipAngle={20}
          arcLabelsTextColor="#111115"
          theme={{ labels: { text: { fontSize: 13, fontWeight: 700 } } }}
        />
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
        {entries.map((d) => (
          <div
            key={d.key}
            style={{ display: "flex", alignItems: "center", gap: "8px", fontSize: "13px" }}
          >
            <span
              style={{
                display: "inline-block",
                width: 9,
                height: 9,
                borderRadius: 2,
                background: DEVICE_COLORS[d.key],
                flexShrink: 0,
              }}
            />
            <span style={{ opacity: 0.8 }}>{DEVICE_LABELS[d.key]}</span>
            <span style={{ marginLeft: "auto", fontWeight: 700 }}>
              {formatNumberWithCommas(d.value)}
            </span>
            <span style={{ opacity: 0.55, fontSize: "12px", width: 38, textAlign: "right" }}>
              {pct(d.value)}%
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default DevicePie;
